"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.JourneyActionVoiceSetLanguage = exports.ASTERISK_LANGUAGE_OPTIONS = void 0;
const base_1 = require("./base");
const enums_1 = require("../../enums");
const constants_1 = require("../constants");
const utils_1 = require("../utils");
const misc_1 = require("../../misc");
exports.ASTERISK_LANGUAGE_OPTIONS = (0, misc_1.EnumValues)(enums_1.VoiceLanguageEnum);
exports.JourneyActionVoiceSetLanguage = (0, base_1.journeyAction)({
    action: enums_1.JourneyActionEnum.VoiceSetLanguage,
    channels: [enums_1.ChannelEnum.Voice,],
    direction: enums_1.JourneyNodeDirectionEnum.Output,
    settings_schema: (0, base_1.settingsValidationSchema)({
        language: {
            type: 'string',
            valid: exports.ASTERISK_LANGUAGE_OPTIONS,
            required: true,
        },
    }),
    getPorts: (node) => {
        return Object.assign(Object.assign({}, base_1.journeyDefaultInputPort), { [constants_1.JOURNEY_ACTION_VOICE_SET_LANGUAGE_OUTPUT]: (0, utils_1.journeyNodePortAddDefault)({
                id: constants_1.JOURNEY_ACTION_VOICE_SET_LANGUAGE_OUTPUT,
                type: enums_1.JourneyPortDirectionEnum.Output,
                removable: false,
                required: true,
                index: 0,
                title: 'DONE',
                color: null,
            }) });
    },
});
